var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("div", {
          ref: "chartOrderNum",
          staticStyle: { width: "50%", height: "350px" },
        }),
        _c("div", {
          ref: "chartAmount",
          staticStyle: { width: "50%", height: "350px" },
        }),
      ]),
      _c(
        "el-form",
        {
          staticStyle: { "margin-top": "10px", "margin-bottom": "-10px" },
          attrs: { "label-width": "40px", inline: "", size: "mini" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "省份", prop: "province_code" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "请选择",
                    clearable: "",
                    filterable: "",
                  },
                  on: { change: _vm.onChangeProvinceCode },
                  model: {
                    value: _vm.filter.province_code,
                    callback: function ($$v) {
                      _vm.$set(_vm.filter, "province_code", $$v)
                    },
                    expression: "filter.province_code",
                  },
                },
                _vm._l(_vm.provinceOptions, function (province) {
                  return _c("el-option", {
                    key: province.code,
                    attrs: { label: province.fullname, value: province.code },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "城市", prop: "city_code" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "请选择",
                    clearable: "",
                    filterable: "",
                    "no-data-text": _vm.filter.province_code
                      ? "无数据"
                      : "请选择省份",
                  },
                  model: {
                    value: _vm.filter.city_code,
                    callback: function ($$v) {
                      _vm.$set(_vm.filter, "city_code", $$v)
                    },
                    expression: "filter.city_code",
                  },
                },
                _vm._l(_vm.cityOptions, function (city) {
                  return _c("el-option", {
                    key: city.code,
                    attrs: { label: city.fullname, value: city.code },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.refreshData },
                },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.searchedWithRegion
        ? _c("el-alert", {
            attrs: {
              title: "当前已应用筛选，合计及占比基于筛选结果计算。",
              type: "warning",
              closable: false,
            },
          })
        : _vm._e(),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-top": "10px" },
          attrs: {
            border: "",
            "header-cell-style": _vm.headerCellStyle,
            data: _vm.list,
            "row-style": _vm.rowStyle,
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "省份", prop: "province_name" },
          }),
          _c("el-table-column", {
            attrs: { label: "城市", prop: "city_name" },
          }),
          _c("el-table-column", {
            attrs: { label: "订单数", prop: "order_num" },
          }),
          _c(
            "el-table-column",
            { attrs: { prop: "amount" } },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "span",
                  { staticClass: "header-field-container" },
                  [
                    _c("span", [_vm._v("消费点数")]),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "订单消费点数=卡消费点数-退回卡点数",
                          placement: "top",
                          "popper-class": "large-tooltip",
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "el-icon-warning-outline header-info-icon",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: { prop: "consume_rate" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(" " + _vm._s(scope.row.consume_rate + "%") + " "),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "span",
                  { staticClass: "header-field-container" },
                  [
                    _c("span", [_vm._v("消费占比")]),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "当前消费点数 / 总计消费点数 *100%",
                          placement: "top",
                          "popper-class": "large-tooltip",
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "el-icon-warning-outline header-info-icon",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            { attrs: { prop: "cost" } },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "span",
                  { staticClass: "header-field-container" },
                  [
                    _c("span", [_vm._v("成本")]),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "卡实际分摊真实成本价A0",
                          placement: "top",
                          "popper-class": "large-tooltip",
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "el-icon-warning-outline header-info-icon",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "el-table-column",
            {
              attrs: { prop: "cost_rate" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(" " + _vm._s(scope.row.cost_rate + "%") + " "),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "span",
                  { staticClass: "header-field-container" },
                  [
                    _c("span", [_vm._v("成本率")]),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "成本 / 卡实际分摊抵扣金额 *100%",
                          placement: "top",
                          "popper-class": "large-tooltip",
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "el-icon-warning-outline header-info-icon",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "10px", "text-align": "right" } },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, prev, pager, next, jumper",
              "current-page": _vm.cityPaging.page,
              "page-size": _vm.cityPaging.pagesize,
              total: _vm.cityPaging.totalCount,
            },
            on: { "current-change": _vm.onChangePage },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }